import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { SessionPublicAPIsForStartFlowApi } from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const createOtp = createAsyncThunk<void, string, ThunkApi>(
  "createOtp",
  async (email, { rejectWithValue }) => {
    try {
      await new SessionPublicAPIsForStartFlowApi().createOtp({ email });
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Codice OTP",
        description:
          "Non siamo riusciti a inviare il codice otp.\n Puoi provare a rigenerare il codice o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
